import { DataBean } from "../DataBean";

export class ThirdLoanEntity extends DataBean {
  public async getThirdLoanEntityCatalog(
    idThirdLoanEntity: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getThirdLoanEntityCatalog_Number",
      [idThirdLoanEntity]
    );
  }

  public async deleteThirdLoanEntity(idThirdLoanEntity: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deleteThirdLoanEntity_Number",
      [idThirdLoanEntity]
    );
  }

  public async updateThirdLoanEntity(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.loans.ThirdLoanEntity_updateThirdLoanEntity_com.quickdataerp.bean.loans.ThirdLoanEntity",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.quickdataerp.bean.loans.ThirdLoanEntity",
        },
      ]
    );
  }
}
